import { a as attr } from './vivid-element.js';

const ariaMixinProperties = [
  "role",
  "ariaAtomic",
  "ariaAutoComplete",
  "ariaBusy",
  "ariaChecked",
  "ariaColCount",
  "ariaColIndex",
  "ariaColIndexText",
  "ariaColSpan",
  "ariaCurrent",
  "ariaDescription",
  "ariaDisabled",
  "ariaExpanded",
  "ariaHasPopup",
  "ariaHidden",
  "ariaInvalid",
  "ariaKeyShortcuts",
  "ariaLabel",
  "ariaLevel",
  "ariaLive",
  "ariaModal",
  "ariaMultiLine",
  "ariaMultiSelectable",
  "ariaOrientation",
  "ariaPlaceholder",
  "ariaPosInSet",
  "ariaPressed",
  "ariaReadOnly",
  "ariaRequired",
  "ariaRoleDescription",
  "ariaRowCount",
  "ariaRowIndex",
  "ariaRowIndexText",
  "ariaRowSpan",
  "ariaSelected",
  "ariaSetSize",
  "ariaSort",
  "ariaValueMax",
  "ariaValueMin",
  "ariaValueNow",
  "ariaValueText",
  "ariaRelevant"
  // Non-standard
];
const ariaAttributeName = (ariaPropertyName) => ariaPropertyName.replace("aria", "aria-").toLowerCase();
const DelegatesAria = (Base) => {
  class DelegatesAriaElement extends Base {
    constructor(...rest) {
      super(...rest);
      for (const ariaProperty of ariaMixinProperties) {
        this[ariaProperty] = null;
      }
    }
  }
  for (const ariaProperty of ariaMixinProperties) {
    attr({ attribute: ariaAttributeName(ariaProperty) })(
      DelegatesAriaElement.prototype,
      ariaProperty
    );
  }
  return DelegatesAriaElement;
};

export { DelegatesAria as D };
